/**
 * @generated SignedSource<<f90e997622242049b5742ac69e7ab679>>
 * @relayHash 5240170c2842b33dc7f4c2435dfc9768
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5240170c2842b33dc7f4c2435dfc9768

import { ConcreteRequest } from 'relay-runtime';
export type ChMedicationType = "FREE_TEXT_MEDICATION" | "PREPARATION" | "SUBSTANCE" | "TEMPLATE";
export type MedicationUnit = "GTT" | "IU" | "MG" | "ML" | "PC" | "PRN" | "PUFF";
export type useChMedicationSearchItemQueryProductQuery$variables = {
  pharmacode: number;
};
export type useChMedicationSearchItemQueryProductQuery$data = {
  readonly ch_medicationProductSearchItem: {
    readonly articles: ReadonlyArray<{
      readonly description: string;
      readonly globalTradeItemNumber: string | null;
      readonly pharmacode: number | null;
      readonly publicPrice: number | null;
    }>;
    readonly atcCode: string | null;
    readonly category: string | null;
    readonly description: string;
    readonly eveningDosage: number | null;
    readonly hasNews: boolean;
    readonly isGeneric: boolean;
    readonly medicationType: ChMedicationType;
    readonly morningDosage: number | null;
    readonly nightDosage: number | null;
    readonly noonDosage: number | null;
    readonly productUrl: any | null;
    readonly therapyDurationDays: number | null;
    readonly unit: MedicationUnit | null;
    readonly usageInstructions: string;
  } | null;
};
export type useChMedicationSearchItemQueryProductQuery = {
  response: useChMedicationSearchItemQueryProductQuery$data;
  variables: useChMedicationSearchItemQueryProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "pharmacode"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "pharmacode",
        "variableName": "pharmacode"
      }
    ],
    "concreteType": "MedicationSearchItem",
    "kind": "LinkedField",
    "name": "ch_medicationProductSearchItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "hasNews",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "MedicationSearchItemArticle",
        "kind": "LinkedField",
        "name": "articles",
        "plural": true,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "globalTradeItemNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "pharmacode",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "publicPrice",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "category",
        "storageKey": null
      },
      (v1/*:: as any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "eveningDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "medicationType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "morningDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nightDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "therapyDurationDays",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "noonDosage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "productUrl",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "unit",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "usageInstructions",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "atcCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isGeneric",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChMedicationSearchItemQueryProductQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChMedicationSearchItemQueryProductQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "5240170c2842b33dc7f4c2435dfc9768",
    "metadata": {},
    "name": "useChMedicationSearchItemQueryProductQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bf7067223d4cfb4455eefb8c71f69583";

export default node;
